import React, { useEffect, useState, useContext } from 'react'
import styles from './user-details.module.scss'
import Button from 'src/components//button/Button'
import Input from 'src/components//input/Input'
import { StateContext } from '../../AppContext'
import { IState, IUser } from 'src/Interface'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import DropDown from 'src/components/dropDown/Dropdown'
import { format } from 'date-fns'
import { isHigherRole, validEmail, validString } from 'src/utils/utils'
import { toast } from 'react-toastify'
import { isValidNumberForRegion } from 'libphonenumber-js'
import { DispatchContext } from 'src/AppContext'


interface IValues {
  firstName: string
  lastName: string
  phone: string
  email: string
  role: string
}

interface IProps {
  close?: any
  showModal: boolean
  hideArchieved: boolean
  branchId: number
  userId: string,
  companyId: number
}

interface IErrors {
  name: boolean
  lastname: boolean
  phone: boolean
  email: boolean
}

const UserDetails: React.FunctionComponent<IProps> = ({ close, userId, companyId, branchId, hideArchieved }: IProps) => {
  const [userActivities, setUserActivity] = useState([])
  const state: IState = useContext(StateContext)
  const [role, setRole] = useState('')
  const dispatch = useContext(DispatchContext)
  const [roles, setRoles] = useState([])
  const userInfo: IUser = state.users.find(user => user.id === Number(userId));
  const [values, setValues] = useState<IValues>({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: ''
  })

  const [errors, setErrors] = useState<IErrors>({
    name: false,
    lastname: false,
    phone: false,
    email: false
  })

  useEffect(() => {
    if (userInfo) {
      setValues({
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        phone: userInfo.phone ? userInfo.phone : '',
        email: userInfo.email,
        role: userInfo.role
      })
    }
  }, [state.users, userId, userInfo])


  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false

    if (fieldName === 'phone') {
      if (!isValidNumberForRegion(value, 'DK')) {
        error = true
      }
    } else {
      if (value && regexp && !regexp.test(value || '')) {
        error = true
      }
    }
    setErrors({
      ...errors,
      [fieldName]: error
    })
  }

  useEffect(() => {
    switch (state.user.role) {
      case 'DanTaxiAdmin':
        if (state.user.companyId === Number(companyId)) {
          setRoles([
            {
              label: 'DanTaxiAdmin',
              value: 'DanTaxiAdmin'
            }
          ])
        } else {
          setRoles([
            {
              label: 'Bruger',
              value: 'BranchEmployee'
            },
            {
              label: 'Manager',
              value: 'BranchAdmin'
            },
            {
              label: 'Admin',
              value: 'CompanyAdmin'
            }
          ]
          )
        }
        break;
      case 'CompanyAdmin':
        setRoles([
          {
            label: 'Bruger',
            value: 'BranchEmployee'
          },
          {
            label: 'Manager',
            value: 'BranchAdmin'
          },
          {
            label: 'Admin',
            value: 'CompanyAdmin'
          }
        ])
        break;
      case 'BranchAdmin':
        setRoles([
          {
            label: 'Bruger',
            value: 'BranchEmployee'
          },
          {
            label: 'Manager',
            value: 'BranchAdmin'
          },
          {
            label: 'Admin',
            value: 'CompanyAdmin',
            isDisabled: true
          }
        ])
        break;
      default:
        break;
    }
  }, [state.user.role, companyId, state.user.companyId])

  useEffect(() => {
    if (state.user.accessToken && userId) {
      axios.get(`${baseApiURL()}/users/${userId}/activities`,
        {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          setUserActivity(result.data)
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
  }, [state.user.accessToken, userId])

  const resetPassword = () => {
    axios.put(`${baseApiURL()}/users/forgot_password`, {
      "email": userInfo.email
    })
      .then(() => {
        toast('Adgangskoden er nulstillet')
        close()
      }).catch((err: any) => {
        toast(err.response.data.message)
      })
  }

  const resendActivationEmail = () => {
    axios.put(`${baseApiURL()}/users/${userId}/invite`, {}, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then(() => {
      toast('E-mail er blevet sendt igen')
      close()
    }).catch((err: any) => {
      toast(err.response.data.amessage)
    })
  }

  const toggleUserStatus = () => {
    axios.post(`${baseApiURL()}/users/${userId}/status`,
      {
        active: userInfo.status === 'ACTIVE' || userInfo.status === 'INVITED' ? false : true
      }, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then(() => {
      return null;
    }).then(() => {
      return axios(`${baseApiURL()}/users${branchId ? `?branchId=${branchId}&companyId=${companyId}` : `?companyId=${companyId}`}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
    }).then((result) => {
      if (userInfo.status === 'ACTIVE' || userInfo.status === 'INVITED') {
        dispatch({ type: 'SHOW_MODAL', showModal: false })
      }
      dispatch({ type: 'SET_USERS', users: hideArchieved ? result.data.filter(user => user.status !== 'INACTIVE') : result.data })
      close()
      toast(userInfo.status === 'ACTIVE' || userInfo.status === 'INVITED' ? 'Brugeren er blevet deaktiveret' : 'Brugeren er blevet genaktiveret')
    }).catch((err: any) => {
      toast(err.response.data.message)
    })
  }

  const updateUserInfo = () => {
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/users/${userId}`,
        {
          firstName: values.firstName ? values.firstName : null,
          lastName: values.lastName ? values.lastName : null,
          phone: values.phone ? values.phone : null,
          email: values.email ? values.email : null,
          status: null,
          role: role ? role : null
        }, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then(() => {
        return null
      }).then(() => {
        return axios(`${baseApiURL()}/users${branchId ? `?branchId=${branchId}&companyId=${companyId}` : `?companyId=${companyId}`}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        })
      }).then((result) => {
        dispatch({ type: 'SET_USERS', users: hideArchieved ? result.data.filter(user => user.status !== 'INACTIVE') : result.data })
        close()
      }).catch((err) => {
        toast(err.response.data.message)
      })
    }
  }

  const clearUserData = () => {
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/users/${userId}/anonymize`,
        {}, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then(() => {
        toast('Brugeren er nu anonymiseret')
        close()
      }).catch((err: any) => {
        toast(err.response.data.message)
      })
    }
  }

  const handleInputChange = (fieldName: string) => (value: string) => {
    setValues({
      ...values,
      [fieldName]: value
    })
  }

  if (!userInfo || !roles.length) {
    return null
  }

  return (
    <>
      <header className={styles.header}>
        <h3>{`${userInfo.firstName} ${userInfo.lastName}`}</h3>
        <span className={styles.closeIcon} onClick={close}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </span>
        <h4 className={styles.role}>{roles.find(role => role.value === userInfo.role) ? roles.find(role => role.value === userInfo.role).label : ''}</h4>
      </header>
      <div className={styles.container}>
        <div className={styles.userInfo}>
          <h4 className={styles.subTitle}>Detaljer</h4>
          <DropDown readOnly={!isHigherRole(state.user, userInfo)} value={userInfo.role} label='Rettigheder' handleOnChange={(e: any) => setRole(e)} options={roles} />
          <hr className='tw-mt-5' />
          <Input
            modifiers='tw-mt-3'
            label='Fornavn *'
            value={values.firstName}
            type='text'
            error={errors.name}
            resetError={() => resetError('firstName')}
            handleValidation={() => handleValidation(validString, 'firstName')}
            handleInputChange={() => handleInputChange('firstName')}
            name='firstname'
            placeholder='Navn'
          />
          <Input
            modifiers='tw-mt-3'
            label='Efternavn *'
            value={values.lastName}
            type='text'
            error={errors.lastname}
            resetError={() => resetError('lastName')}
            handleValidation={() => handleValidation(validString, 'lastName')}
            handleInputChange={() => handleInputChange('lastName')}
            name='lastname'
            placeholder='Efternavn'
          />
          <Input
            modifiers='tw-mt-3'
            label='Telefon'
            value={values.phone}
            countryCode='+45'
            error={errors.phone}
            resetError={() => resetError('phone')}
            type='text'
            isAllowOnlyDigits
            name='mobile'
            handleValidation={() => handleValidation(null, 'phone')}
            handleInputChange={() => handleInputChange('phone')}
            placeholder='Indtast nr.'
          />

          <Input
            modifiers='tw-mt-3 tw-mb-5'
            label='E-mail *'
            value={values.email}
            error={errors.email}
            resetError={() => resetError('email')}
            type='text'
            handleValidation={() => handleValidation(validEmail, 'email')}
            handleInputChange={() => handleInputChange('email')}
            name='email'
            placeholder='indtast e-mail' />
          {userInfo.status === 'INACTIVE' && <Button type='destructive' label='Anonymiser bruger' modifiers='tw-w-full tw-mb-5' handleClick={clearUserData} />}
          <hr className={styles.divider} />
          <div className='tw-flex tw-mt-3'>
            {userInfo.status !== 'INACTIVE' && Number(state.user.id) !== Number(userInfo.id) &&
              isHigherRole(state.user, userInfo) && <Button type='minimalDestructive' modifiers='tw-ml-auto tw-mr-3' handleClick={() => dispatch({ type: 'SHOW_MODAL', modalType: 'deleteConfirmation', showModal: true, title: 'Fjern Medarbejder', text: '<p>Er du sikker på at du vil fjerne denne medarbejder?</p> <p>Dette kan ikke fortrydes.</p>', buttonText: 'Fjern medarbejder', handleDelete: toggleUserStatus })} label={userInfo.status === 'ACTIVE' ? 'Deaktivér' : 'Fjern bruger'} />}
            {userInfo.status === 'INACTIVE' && <Button type='primary' modifiers='tw-ml-auto tw-mr-3' handleClick={toggleUserStatus} label='Aktivér' />}
            <Button type='minimal' modifiers='tw-ml-auto' handleClick={userInfo.status === 'INVITED' ? resendActivationEmail : resetPassword} label={userInfo.status === 'INVITED' ? 'Send e-mail-aktivering igen' : 'Nulstil password'} />
          </div>
        </div>
        <div className={styles.userActivity}>
          <h4 className={styles.subTitle}>Aktivitet</h4>
          <ul className={styles.list}>
            {userActivities.map((activity, i) => (
              <li key={i} className={styles.item}>
                <span className={styles.activity}>{activity.description}</span>
                <span className={styles.date}>{format(new Date(activity.timestamp), 'HH:mm, d/MM/yyyy')}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <footer className={styles.footer}>
        <Button modifiers='tw-ml-auto' type='primary' label='Gem ændringer' handleClick={updateUserInfo} />
      </footer>
    </>
  )
}

export default UserDetails
